import { styled } from "@mui/material/styles";
import { Tooltip, TooltipProps } from "@mui/material";

/* https://mui.com/material-ui/react-tooltip/#customization */
const StyledTooltip = styled(
  ({ className, children, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }}>
      {children}
    </Tooltip>
  )
)`
  & .MuiTooltip-tooltip {
    background: ${props => props.theme.palette.secondary.main};
    color: ${props => props.theme.palette.secondary.contrastText};
  }

  & .MuiTooltip-arrow {
    color: ${props => props.theme.palette.secondary.main};
  }
`;

export const MenuTooltip = ({
  arrow = true,
  placement = "top",
  ...tooltipProps
}: TooltipProps): JSX.Element => {
  return (
    <StyledTooltip arrow={arrow} placement={placement} {...tooltipProps} />
  );
};
